// extracted by mini-css-extract-plugin
export var accordion = "_hp-0";
export var chevron = "_hp-3";
export var closed = "_hp-2";
export var content = "_hp-4";
export var open = "_hp-1";
export var rotate = "_hp-5";